import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Log } from '@shared/debug/log';

export class MissingTranslationReporter implements MissingTranslationHandler {
  public deactivated = false;
  private alreadyLogged = new Set<string>();

  handle(params: MissingTranslationHandlerParams) {
    if(this.deactivated) return params.key;
    this.logMissingTranslationKey(params.key);
    return params.key;
  }

  logMissingTranslationKey(key: string) {
    if(this.alreadyLogged.has(key)) return;
    this.alreadyLogged.add(key);

    Log.error("MISSING TRANSLATION - Key exists in neither English nor the selected language:", key);
  }
}
